import React from "react";
import ServicePageShell from "../ui/ServicePageShell";
import ServicePageCta from "../ui/ServicePageCta";
import { PrimaryLink } from "../ui/Buttons";
import SeoHead from "../seo/SeoHead";
import PageBreadcrumb from "../seo/PageBreadcrumb";
import ALT from "../../assets/Alternator.png";

const AlternatorReplacement = () => {
  return (
    <>
      <SeoHead
        title="Alternator Replacement in Temecula | Advanced Automotive Smog"
        description="Alternator testing and replacement in Temecula for dim lights, weak starts, or charging issues, using quality parts built to last."
        path="/services/alternator-replacement"
      />
      <ServicePageShell>
        <PageBreadcrumb
          label="Alternator Replacement"
          path="/services/alternator-replacement"
          description="Alternator testing and replacement in Temecula for dim lights, weak starts, or charging issues."
          serviceType="Alternator replacement"
        />
        <div className="flex flex-col gap-10 md:flex-row md:items-center md:gap-14">
          {/* Image - prioritized for mobile */}
          <div className="w-full md:w-1/2 flex justify-center order-1 md:order-none">
            <div className="relative w-full max-w-xs sm:max-w-sm">
              <div className="absolute -inset-3 rounded-3xl bg-teal-600/10 blur-xl" />
              <img
                src={ALT}
                alt="Alternator replacement service"
                className="relative w-full h-auto rounded-3xl border border-slate-200 object-cover shadow-xl"
              />
            </div>
          </div>

          {/* Text content */}
          <div className="w-full md:w-1/2">
            <div className="mb-4 inline-flex items-center gap-2 rounded-full border border-slate-200 bg-slate-50 px-2.5 py-1 text-[11px] font-medium tracking-normal text-teal-700">
              <span className="h-1.5 w-1.5 rounded-full bg-teal-600" />
              Electrical System Service
            </div>

            <h1 className="text-2xl sm:text-3xl md:text-4xl font-bold tracking-tight text-navy-900 mb-3">
              Alternator Replacement
            </h1>

            <p className="text-sm sm:text-base text-slate-700 mb-6 leading-relaxed">
              Dim lights, weak starts, or a dead battery can all point to a
              failing alternator. We replace worn alternators with quality parts
              so your vehicle&apos;s power stays reliable every time you turn
              the key.
            </p>

            <h2 className="text-lg sm:text-xl font-semibold text-teal-600 mb-2">
              What is Alternator Replacement?
            </h2>

            <p className="text-sm sm:text-base text-slate-700 mb-5 leading-relaxed">
              The alternator keeps your battery charged and powers your
              headlights, dashboard, and other electrical systems while the
              engine is running. When it wears out, your battery drains quickly
              and you&apos;re at risk of being stranded.
              <br />
              <br />
              Our service includes complete alternator diagnostics, removal of
              the old unit, installation of a new high-quality alternator, and
              final testing to make sure your charging system is working
              exactly as it should.
            </p>

            <ul className="space-y-2.5 text-sm sm:text-base text-slate-700">
              <li className="flex items-start gap-2">
                <span className="mt-1 h-1.5 w-1.5 rounded-full bg-teal-600" />
                <span>Full alternator diagnostics and output testing</span>
              </li>
              <li className="flex items-start gap-2">
                <span className="mt-1 h-1.5 w-1.5 rounded-full bg-teal-600" />
                <span>High-quality replacement units for most vehicles</span>
              </li>
              <li className="flex items-start gap-2">
                <span className="mt-1 h-1.5 w-1.5 rounded-full bg-teal-600" />
                <span>Professional removal and installation</span>
              </li>
              <li className="flex items-start gap-2">
                <span className="mt-1 h-1.5 w-1.5 rounded-full bg-teal-600" />
                <span>Helps prevent sudden battery and electrical failures</span>
              </li>
              <li className="flex items-start gap-2">
                <span className="mt-1 h-1.5 w-1.5 rounded-full bg-teal-600" />
                <span>Final system check for voltage and charging health</span>
              </li>
            </ul>

            {/* Clean centered button */}
            <div className="mt-8 flex justify-center">
              <PrimaryLink
                to="/contact"
                className="px-10 text-base"
              >
                Book Appointment
              </PrimaryLink>
            </div>
          </div>
        </div>
            <ServicePageCta />
      </ServicePageShell>
    </>
  );
};

export default AlternatorReplacement;

